import Link from "next/link"

export const PreviewButton = () => {
  return <div style={{position:'absolute', top:25, zIndex: 10000, justifyContent: 'center', }}>
    <Link className="container" href="/api/sanity/exit-preview">
      <button className="btn salmon" style={{background: 'red'}}>Exit Preview</button>
    </Link>
  </div>
}